module.exports = __webpack_public_path__ + "static/img/2.5373da3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/sp/2.png
// module id = FlVs
// module chunks = 0